
// ============================================================================
// DECOMPOSITION MAP - PART 14
// Final batch: beverages, sauces, bakery, snacks, pasta
// ============================================================================

// Fixed: Imported DecompositionEntry from db-types instead of decomposition-map
import { DecompositionEntry } from './db-types';

export const finalCompleteBatch: DecompositionEntry[] = [
  // ==========================================================================
  // BEVERAGES
  // ==========================================================================
  { foodId: "club_soda", ingredients: ["water"] },
  { foodId: "diet_soda", ingredients: ["water", "sweetener"] },
  { foodId: "instant_coffee", ingredients: ["coffee"] },
  { foodId: "jamaica_drink", ingredients: ["hibiscus", "sugar", "water"] },
  { foodId: "kompot", ingredients: ["fruit", "sugar", "water"] },
  { foodId: "kvass", ingredients: ["rye", "sugar", "yeast", "water"] },
  { foodId: "lemon_juice", ingredients: ["lemon"] },
  { foodId: "lemon_lime_soda", ingredients: ["water", "lemon", "lime", "sugar"] },
  { foodId: "lime_juice", ingredients: ["lime"] },
  { foodId: "macchiato", ingredients: ["coffee", "milk"] },
  { foodId: "matcha", ingredients: ["tea"] },
  { foodId: "mineral_water", ingredients: ["water"] },
  { foodId: "oolong_tea", ingredients: ["tea"] },
  { foodId: "peppermint_tea", ingredients: ["mint"] },
  { foodId: "protein_shake", ingredients: ["milk", "whey", "banana", "peanut"] },
  { foodId: "rooibos", ingredients: ["rooibos"] },
  { foodId: "rose_lassi", ingredients: ["yogurt", "sugar", "rose", "cardamom"] },
  { foodId: "soda", ingredients: ["water", "sugar"] },
  { foodId: "sports_drink", ingredients: ["water", "sugar", "electrolyte"] },
  { foodId: "tamarindo_drink", ingredients: ["tamarind", "sugar", "water"] },
  { foodId: "tea", ingredients: ["tea"] },
  { foodId: "thai_iced_tea", ingredients: ["tea", "milk", "sugar", "ice"] },
  { foodId: "turkish_coffee", ingredients: ["coffee", "sugar"] },
  { foodId: "vegetable_juice", ingredients: ["carrot", "tomato", "celery", "beet"] },
  { foodId: "vietnamese_coffee", ingredients: ["coffee", "milk", "sugar"] },
  { foodId: "water", ingredients: ["water"] },

  // ==========================================================================
  // SAUCES
  // ==========================================================================
  { foodId: "basil_pesto", ingredients: ["basil", "pine_nut", "parmesan", "garlic", "olive_oil", "salt"] },
  { foodId: "coconut_aminos", ingredients: ["coconut", "salt"] },
  { foodId: "dark_soy_sauce", ingredients: ["soybean", "wheat", "salt", "molasses"] },
  { foodId: "light_soy_sauce", ingredients: ["soybean", "wheat", "salt"] },
  { foodId: "miso", ingredients: ["soybean", "rice", "salt"] },
  { foodId: "plum_sauce", ingredients: ["plum", "sugar", "vinegar", "ginger", "chili_pepper"] },
  { foodId: "red_miso", ingredients: ["soybean", "barley", "salt"] },
  { foodId: "remoulade", ingredients: ["mayonnaise", "mustard", "pickle", "caper", "onion", "parsley", "lemon"] },
  { foodId: "salsa", ingredients: ["tomato", "onion", "chili_pepper", "cilantro", "lime", "salt"] },
  { foodId: "shaoxing_wine", ingredients: ["rice"] },
  { foodId: "sun_dried_tomato_pesto", ingredients: ["tomato", "almond", "parmesan", "garlic", "olive_oil", "basil", "salt"] },
  { foodId: "tahina", ingredients: ["sesame", "olive_oil", "lemon", "garlic", "salt"] },
  { foodId: "tamari", ingredients: ["soybean", "salt"] },
  { foodId: "tamarind_chutney", ingredients: ["tamarind", "sugar", "cumin", "ginger", "chili_pepper", "salt"] },
  { foodId: "tapenade", ingredients: ["olive", "anchovy", "caper", "garlic", "olive_oil", "lemon", "thyme"] },
  { foodId: "fish_sauce_thai", ingredients: ["anchovy", "salt"] },
  { foodId: "white_gravy", ingredients: ["butter", "flour", "milk", "broth", "salt", "black_pepper"] },
  { foodId: "white_miso", ingredients: ["soybean", "rice", "salt"] },

  // ==========================================================================
  // BAKERY ITEMS
  // ==========================================================================
  { foodId: "food_coloring", ingredients: ["colorant"] },
  { foodId: "macaroon", ingredients: ["coconut", "egg_white", "sugar", "vanilla"] },
  { foodId: "madeleines", ingredients: ["flour", "egg", "butter", "sugar", "lemon", "baking_powder", "vanilla"] },
  { foodId: "marzipan", ingredients: ["almond", "sugar", "egg_white"] },
  { foodId: "pastry_flour", ingredients: ["wheat"] },
  { foodId: "pectin", ingredients: ["pectin"] },
  { foodId: "potato_starch", ingredients: ["potato"] },
  { foodId: "rice_flour", ingredients: ["rice"] },
  { foodId: "scones_uk", ingredients: ["flour", "butter", "milk", "egg", "sugar", "baking_powder", "raisin", "salt"] },
  { foodId: "self_rising_flour", ingredients: ["flour", "baking_powder", "salt"] },
  { foodId: "sprinkles", ingredients: ["sugar", "colorant"] },
  { foodId: "sticky_bun", ingredients: ["flour", "butter", "egg", "yeast", "milk", "sugar", "cinnamon", "pecan", "caramel", "salt"] },
  { foodId: "tapioca_flour", ingredients: ["tapioca"] },
  { foodId: "tuile", ingredients: ["flour", "butter", "egg_white", "sugar", "almond"] },
  { foodId: "whole_wheat_flour", ingredients: ["wheat"] },
  { foodId: "yeast", ingredients: ["yeast"] },

  // ==========================================================================
  // SNACKS
  // ==========================================================================
  { foodId: "cheese_sticks", ingredients: ["cheddar", "flour", "vegetable_oil", "salt"] },
  { foodId: "chewing_gum", ingredients: ["gum", "sugar", "mint"] },
  { foodId: "fruit_leather", ingredients: ["fruit", "sugar"] },
  { foodId: "fruit_snacks", ingredients: ["fruit", "sugar", "gelatin"] },
  { foodId: "graham_crackers", ingredients: ["flour", "wheat", "honey", "cinnamon", "baking_soda", "salt"] },
  { foodId: "jelly_beans", ingredients: ["sugar", "gelatin", "corn_syrup"] },
  { foodId: "licorice", ingredients: ["flour", "molasses", "anise", "sugar"] },
  { foodId: "lollipop", ingredients: ["sugar", "corn_syrup", "flavor"] },
  { foodId: "mints", ingredients: ["sugar", "mint"] },
  { foodId: "rice_cakes", ingredients: ["rice", "salt"] },
  { foodId: "edamame_snack", ingredients: ["soybean", "salt"] },
  { foodId: "saltines", ingredients: ["flour", "salt", "yeast", "vegetable_oil"] },
  { foodId: "seaweed_snack", ingredients: ["seaweed", "sesame_oil", "salt"] },
  { foodId: "toffee", ingredients: ["sugar", "butter", "cream"] },

  // ==========================================================================
  // PASTA
  // ==========================================================================
  { foodId: "sweet_potato_noodles", ingredients: ["sweet_potato", "salt"] },
  { foodId: "tortelloni", ingredients: ["flour", "egg", "ricotta", "spinach", "parmesan", "nutmeg", "salt"] },

  // ==========================================================================
  // MISSING BASE INGREDIENTS
  // ==========================================================================
  { foodId: "treacle", ingredients: ["molasses", "sugar"] },
  { foodId: "gum_arabic", ingredients: ["gum_arabic"] },
  { foodId: "hibiscus", ingredients: ["hibiscus"] },
  { foodId: "rooibos", ingredients: ["rooibos"] },
  { foodId: "electrolyte", ingredients: ["sodium", "potassium"] },
  { foodId: "colorant", ingredients: ["colorant"] },
  { foodId: "whey", ingredients: ["milk"] },
  { foodId: "gum", ingredients: ["gum"] },
  { foodId: "flavor", ingredients: ["flavor"] },
  { foodId: "graham_cracker", ingredients: ["flour", "wheat", "honey", "cinnamon"] },
  { foodId: "cookie", ingredients: ["flour", "butter", "sugar", "egg"] },
  { foodId: "sodium", ingredients: ["salt"] },
  { foodId: "potassium", ingredients: ["potassium"] },
];
